import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useState } from "react";
import "./Habilidades.css";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { HabilidadesContext } from "../../contexts/HabilidadesContext";
import { Dropdown } from "primereact/dropdown";
import { Rating } from "primereact/rating";

export const ModalHabilidaes = ({
  position,
  cancel,
  infoModal,
  skills,
  guardarSkill,
  datos,
  editSkill,
  setEditSkill,
  deleteSkills,
  updateSkills,
  tecnologias,
  subTecnologias,
  guardarCertificaciones,
  guardarCurriculum,
  nivelEstudios,
  open,
}) => {
  const {
    habilidadSeleccionada,
    setHabilidadSeleccionada,
    putCertificaciones,
    putCurriculum,
    putNivelEstudios,
    getSubTecnologias,
    postNivelEstudios,
    postTenologias,
    putTecnologias,
    postSugerencias,
  } = useContext(HabilidadesContext);
  const [skillsSeleccionadas, setSkillsSeleccionadas] = useState([]);
  const [SubskillsSeleccionadas, setSubskillsSeleccionadas] = useState(
    habilidadSeleccionada
      ? {
          name: habilidadSeleccionada.subtechnologyName,
          _id: habilidadSeleccionada.idSubtechnology,
        }
      : ""
  );
  const [tecnologiaSeleccionada, setTenologiaSeleccionada] = useState(
    habilidadSeleccionada
      ? {
          name: habilidadSeleccionada.technologyName,
          _id: habilidadSeleccionada.idTechnology,
          assessment: habilidadSeleccionada.assessment,
          validated: habilidadSeleccionada.validated,
        }
      : ""
  );
  const [subExistente, setSubExistente] = useState(false);
  const [filtros, setFiltros] = useState([]);
  const [skillsActualizar, setSkillsActualizar] = useState([]);
  const [skillsEliminar, setSkillsEliminar] = useState([]);
  const [archivo, setArchivo] = useState("");
  const [inputOne, setInputOne] = useState(
    habilidadSeleccionada ? habilidadSeleccionada.certificationTitle : ""
  );
  const [inputTwo, setInputTwo] = useState(
    habilidadSeleccionada ? habilidadSeleccionada.institutionName : ""
  );
  const [nivelEstudio, setNivelEstudio] = useState(
    habilidadSeleccionada ? { name: habilidadSeleccionada.levelAchieved } : ""
  );
  const [titulo, setTitulo] = useState(
    habilidadSeleccionada ? habilidadSeleccionada.degree : ""
  );
  const [nombreInsti, setNombreInsti] = useState(
    habilidadSeleccionada ? habilidadSeleccionada.institution : ""
  );
  const [archivoExistente, setArchivoExistente] = useState(
    habilidadSeleccionada && habilidadSeleccionada.fileName
  );
  const [sugerenciaTecnologia, setSugerenciaTecnologia] = useState("");
  const [sugerenciaSubtecnologia, setSugerenciaSubtecnologia] = useState("");
  const onHide = () => {
    cancel(false);
    setEditSkill(false);
    setHabilidadSeleccionada("");
    if (
      (infoModal === "Nivel de estudios" || infoModal === "Skill Principal") &&
      editSkill
    ) {
      open(true);
    }
  };
  const headerContent = (
    <div>
      <p className="p1-modal-habilidades">{`${
        editSkill ? "Editar" : "Añadir"
      } ${infoModal}`}</p>
    </div>
  );

  useEffect(() => {
    if (infoModal === "Skill Principal" && editSkill) {
      getSubTecnologias(tecnologiaSeleccionada._id);
    }
  }, []);

  useEffect(() => {
    if (infoModal === "Práctica" && editSkill) {
      const transformedSkills = datos.map((skill) => ({
        _id: skill.idSkill,
        idObjet: skill._id,
        name: skill.name,
        assessment: skill.assessment,
        validated: skill.validated,
      }));
      setSkillsSeleccionadas(transformedSkills);
    }
  }, [infoModal, datos]);

  useEffect(() => {
    setFiltros([...skillsSeleccionadas]);
  }, [skillsSeleccionadas, datos]);

  useEffect(() => {
    if (tecnologiaSeleccionada && !editSkill && infoModal === "Skill Principal") {
      setFiltros((prevFiltros) => {
        const filtroExistente = prevFiltros.find(
          (filtro) => filtro.tecnologia._id === tecnologiaSeleccionada._id
        );
        const existeSubtecnologia = prevFiltros.some(
          (filtro) => filtro.subtecnologia
        );

        if (existeSubtecnologia && SubskillsSeleccionadas !== "") {
          setSubExistente(
            prevFiltros.find(
              (filtro) =>
                filtro.subtecnologia?.name === SubskillsSeleccionadas?.name
            )
          );
        }

        if (filtroExistente && !subExistente && SubskillsSeleccionadas !== "") {
          setSubExistente(true);
          return prevFiltros.map((filtro) =>
            filtro.tecnologia._id === tecnologiaSeleccionada._id
              ? {
                  ...filtro,
                  subtecnologia: SubskillsSeleccionadas,
                  name: `${filtro.tecnologia.name} - ${SubskillsSeleccionadas.name}`,
                }
              : filtro
          );
        } else if (!filtroExistente) {
          const nuevoFiltro = {
            _id: `${tecnologiaSeleccionada._id}-${
              SubskillsSeleccionadas?._id || "no-sub"
            }`,
            name: SubskillsSeleccionadas
              ? `${tecnologiaSeleccionada.name} - ${SubskillsSeleccionadas.name}`
              : tecnologiaSeleccionada.name,
            tecnologia: tecnologiaSeleccionada,
            subtecnologia: SubskillsSeleccionadas || null,
          };
          setSubExistente(false);
          return [...prevFiltros, nuevoFiltro];
        } else if (SubskillsSeleccionadas !== "") {
          const subtecnologiaExistente = prevFiltros.some(
            (filtro) =>
              filtro.tecnologia._id === tecnologiaSeleccionada._id &&
              filtro.subtecnologia?._id === SubskillsSeleccionadas._id
          );

          if (subtecnologiaExistente) {
            return prevFiltros;
          }

          const nuevoFiltro = {
            _id: `${tecnologiaSeleccionada._id}-${
              SubskillsSeleccionadas?._id || "sub"
            }`,
            name: SubskillsSeleccionadas
              ? `${tecnologiaSeleccionada.name} - ${SubskillsSeleccionadas.name}`
              : tecnologiaSeleccionada.name,
            tecnologia: tecnologiaSeleccionada,
            subtecnologia: SubskillsSeleccionadas || null,
          };

          setSubExistente(true);
          return [...prevFiltros, nuevoFiltro];
        }
        return prevFiltros;
      });

      if (tecnologiaSeleccionada && SubskillsSeleccionadas) {
        setTenologiaSeleccionada("");
        setSubskillsSeleccionadas("");
      }
    }
  }, [tecnologiaSeleccionada, SubskillsSeleccionadas]);

  useEffect(() => {
    infoModal === "Skill Principal" && setFiltros([]);
  }, []);

  const handleRating = (e, element) => {
    if (infoModal === "Práctica") {
      if (editSkill) {
        setSkillsActualizar((prevSkills) => {
          const skillExistente = prevSkills.find(
            (skill) => skill._id === element._id
          );
          if (skillExistente) {
            return prevSkills.map((skill) =>
              skill._id === element._id
                ? { ...skill, assessment: e.value }
                : skill
            );
          }
          return [...prevSkills, { _id: element.idObjet, assessment: e.value }];
        });
      }
      setSkillsSeleccionadas(
        skillsSeleccionadas.map((item) =>
          item._id === element._id ? { ...item, assessment: e.value } : item
        )
      );
    } else if (infoModal === "Skill Principal") {
      if (editSkill) {
        setTenologiaSeleccionada((prevSkills) => {
          return { ...prevSkills, assessment: e.value };
        });
      } else {
        setFiltros(
          filtros.map((item) =>
            item._id === element._id ? { ...item, assessment: e.value } : item
          )
        );
      }
    }
  };

  const handleSkills = (e) => {
    setSkillsSeleccionadas(e.value);
  };

  const removeFiltro = (filtro) => {
    const nuevosFiltros = filtros.filter((item) => item._id !== filtro._id);
    setFiltros(nuevosFiltros);
    setSkillsSeleccionadas(nuevosFiltros);
    if (editSkill) {
      setSkillsEliminar((prevSkills) => [...prevSkills, filtro]);
    }
  };

  const handleGuardarSkills = () => {
    guardarSkill(skillsSeleccionadas);
  };

  const handleGuardarTecnologias = () => {
    const tecnologia = filtros.map((filtro) => ({
      technology: filtro.tecnologia._id,
      subtechnology: filtro.subtecnologia?._id || null,
      assessment: filtro.assessment || 1,
    }));
    postTenologias(tecnologia);
    cancel(false);
  };

  const handleEditarTecnologias = () => {
    const tecnologia = {
      id: habilidadSeleccionada._id,
      technology: tecnologiaSeleccionada._id,
      subtechnology: SubskillsSeleccionadas._id || null,
      assessment: tecnologiaSeleccionada.assessment || 1,
    };
    putTecnologias(tecnologia);
    cancel(false);
    open(true);
  };

  const handleGuardarCertificaciones = () => {
    const skill = {
      certificationTitle: inputOne,
      institutionName: inputTwo,
      certificacionFile: archivo,
    };
    guardarCertificaciones(skill);
  };

  const handleEditarCertificaciones = () => {
    const skill = {
      id: habilidadSeleccionada._id,
      certificationTitle: inputOne,
      institutionName: inputTwo,
      certificacionFile: archivo,
    };
    putCertificaciones(skill);
    setEditSkill(false);
    setHabilidadSeleccionada("");
    cancel(false);
  };

  const handleGuardarCurriculum = () => {
    const curriculum = {
      curriculumFile: archivo,
    };
    guardarCurriculum(curriculum);
  };

  const handleEditarCurriculum = () => {
    const curriculum = {
      id: habilidadSeleccionada._id,
      curriculumFile: archivo,
    };
    putCurriculum(curriculum);
    setEditSkill(false);
    setHabilidadSeleccionada("");
    cancel(false);
  };

  const handleEliminarYActualizarSkills = () => {
    if (skillsEliminar.length > 0) {
      const arrayDeIds = skillsEliminar.map((filtro) => ({
        _id: filtro.idObjet,
      }));
      deleteSkills(arrayDeIds);
    }
    if (skillsActualizar.length > 0) {
      updateSkills(skillsActualizar);
    }
  };

  const handleGuardarNivelEstudios = () => {
    const skill = {
      idLevelAchieved: nivelEstudio._id,
      degree: titulo,
      institution: nombreInsti,
    };
    postNivelEstudios(skill);
    cancel(false);
  };

  const handleEditarNivelEstudio = () => {
    const skill = {
      id: habilidadSeleccionada._id,
      idLevelAchieved: nivelEstudio._id,
      degree: titulo,
      institution: nombreInsti,
    };
    putNivelEstudios(skill);
    cancel(false);
    open(true);
  };

  const transformSkills = (skills) => {
    if (!editSkill && datos.length > 0) {
      skills = skills.filter(
        (skill) => !datos.some((datosItem) => datosItem.name === skill.name)
      );
    }
    return skills.map((skill) => {
      const { _id, name } = skill;
      return { _id, name };
    });
  };

  const getModalTitle = () => {
    if (infoModal === "Certificaciones") {
      return "Título de la certificación*";
    } else if (infoModal === "Práctica") {
      return "Skill";
    } else if (infoModal === "Carga de cv") {
      return "Carga tu cv";
    } else if (
      infoModal === "Nivel de estudios" ||
      infoModal === "sugerencia de tecnología"
    ) {
      return "";
    }
    return infoModal;
  };
  const tamañoMaxArchivo = 2 * 1000 * 1000;
  const chooseOptions = {
    icon: "pi pi-fw pi-paperclip",
    iconOnly: true,
    className: "custom-choose-btn p-button-rounded p-button-outlined",
  };

  const opcionesPractica = [
    { name: "Web UI", code: "1" },
    { name: "SysAdmin", code: "2" },
    { name: "Solution Architecture", code: "3" },
    { name: "Software Architecture", code: "4" },
    { name: "SAP Tech", code: "5" },
    { name: "SAP Functional", code: "6" },
    { name: "Salesforce", code: "7" },
    { name: "RPA", code: "8" },
    { name: "QA Security", code: "9" },
    { name: "QA Performance", code: "10" },
    { name: "QA Manual", code: "11" },
    { name: "QA Automation", code: "12" },
    { name: "Python", code: "13" },
    { name: "Project Management", code: "14" },
    { name: "Power Builder", code: "15" },
    { name: "PMO", code: "16" },
    { name: "Oracle Tech", code: "17" },
    { name: "Oracle Functional", code: "18" },
    { name: "Operations Desk", code: "19" },
    { name: "Node", code: "20" },
    { name: "Mobile", code: "21" },
    { name: "Microsoft Dynamics", code: "22" },
    { name: "JAVA", code: "23" },
    { name: "IT Support", code: "24" },
    { name: "Integration", code: "25" },
    { name: "DevOps", code: "26" },
    { name: "DBA", code: "27" },
    { name: "Data Science", code: "28" },
    { name: "Data Engineering", code: "29" },
    { name: "Cybersecurity", code: "30" },
    { name: "Cobol/Mainframe", code: "31" },
    { name: "Cloud", code: "32" },
    { name: "Business Analyst", code: "33" },
    { name: "BPM", code: "34" },
    { name: "Big Data", code: "35" },
    { name: "Data Governance", code: "36" },
    { name: "BI", code: "37" },
    { name: "Batch Processes", code: "38" },
    { name: "Application Support", code: "39" },
    { name: ".NET", code: "40" },
  ];
  
  
  const opcionesSkillPrincipal = [
    { name: "React", code: "4" },
    { name: "Angular", code: "5" },
    { name: "Vue.js", code: "6" },
    { name: "HTML", code: "7" },
    { name: "CSS", code: "8" },
    { name: "JavaScript", code: "9" },
    { name: "TypeScript", code: "10" },
    { name: "Bootstrap", code: "11" },
    { name: "jQuery", code: "12" },
    { name: "SASS", code: "13" },
    { name: "LESS", code: "14" },
    { name: "Next.js", code: "15" },
    { name: "Nuxt.js", code: "16" },
    { name: "Tailwind CSS", code: "17" },
    { name: "Webpack", code: "18" },
    { name: "Linux", code: "19" },
    { name: "Windows Server", code: "20" },
    { name: "Active Directory", code: "21" },
    { name: "Ansible", code: "22" },
    { name: "Nagios", code: "23" },
    { name: "Zabbix", code: "24" },
    { name: "Shell Scripting", code: "25" },
    { name: "TOGAF", code: "26" },
    { name: "Archimate", code: "27" },
    { name: "Design Patterns", code: "28" },
    { name: "Integration Design", code: "29" },
    { name: "Event-Driven Architecture", code: "30" },
    { name: "API Management", code: "31" },
    { name: "Cloud-Native Patterns", code: "32" },
    { name: "Event Storming", code: "33" },
    { name: "Microservices Design", code: "34" },
    { name: "Microservices", code: "35" },
    { name: "DDD", code: "36" },
    { name: "Clean Architecture", code: "37" },
    { name: "Hexagonal Architecture", code: "38" },
    { name: "Monolith to Microservices", code: "39" },
    { name: "ABAP", code: "40" },
    { name: "SAPUI5", code: "41" },
    { name: "OData", code: "42" },
    { name: "BAPI", code: "43" },
    { name: "BADIs", code: "44" },
    { name: "BDC", code: "45" },
    { name: "SmartForms", code: "46" },
    { name: "Fiori", code: "47" },
    { name: "SAP PI/PO", code: "48" },
    { name: "CDS Views", code: "49" },
    { name: "ALE", code: "50" },
    { name: "IDoc", code: "51" },
    { name: "SAP Workflow", code: "52" },
    { name: "Enhancement Framework", code: "53" },
    { name: "Web Dynpro ABAP", code: "54" },
    { name: "SAP Gateway", code: "55" },
    { name: "BRF+", code: "56" },
    { name: "SAP Screen Personas", code: "57" },
    { name: "SAP MM", code: "58" },
    { name: "SAP FI", code: "59" },
    { name: "SAP SD", code: "60" },
    { name: "SAP CO", code: "61" },
    { name: "SAP HCM", code: "62" },
    { name: "SAP PP", code: "63" },
    { name: "SAP PM", code: "64" },
    { name: "SAP CRM", code: "65" },
  ];
  

  const opcionesOtrasSkills = [
    { name: "React", code: "1" },
    { name: "Angular", code: "2" },
    { name: "Vue.js", code: "3" },
    { name: "HTML", code: "4" },
    { name: "CSS", code: "5" },
    { name: "JavaScript", code: "6" },
    { name: "TypeScript", code: "7" },
    { name: "Bootstrap", code: "8" },
    { name: "jQuery", code: "9" },
    { name: "SASS", code: "10" },
    { name: "LESS", code: "11" },
    { name: "Next.js", code: "12" },
    { name: "Nuxt.js", code: "13" },
    { name: "Tailwind CSS", code: "14" },
    { name: "Webpack", code: "15" },
    { name: "Linux", code: "16" },
    { name: "Windows Server", code: "17" },
    { name: "Active Directory", code: "18" },
    { name: "Ansible", code: "19" },
    { name: "Nagios", code: "20" },
    { name: "Zabbix", code: "21" },
    { name: "Shell Scripting", code: "22" },
    { name: "TOGAF", code: "23" },
    { name: "Archimate", code: "24" },
  ];
  

  const handleSugerirTecnologia = () => {
    const sugerencia = {
      technology: sugerenciaTecnologia,
      subtechnology: sugerenciaSubtecnologia,
    };
    postSugerencias(sugerencia);
    cancel(false);
  };

  return (
    <Dialog
      draggable={false}
      closable={true}
      id="custom-bg-modal"
      style={{
        minWidth: "614px",
        maxWidth: "800px",
        height: "500px",
      }}
      className="custom-modal"
      visible={true}
      position={position}
      onHide={() => onHide("onHide")}
      header={headerContent}
    >
      <div style={{ padding: "15px 20px 10px 20px" }}>
        <label className="h2-modal-habilidades">{getModalTitle()}</label>

        {infoModal === "Práctica" && !editSkill && (
          <MultiSelect
            placeholder={`Seleccioná una ${
              infoModal === "Práctica" ? "Skill" : infoModal
            }`}
            style={{ width: "100%", height: "41px" }}
            className="w-full md:w-20rem select-clientes-home"
            panelClassName="modal-skills"
            filter
            options={transformSkills(opcionesPractica)}
            optionLabel="name"
            value={transformSkills(skillsSeleccionadas)}
            onChange={handleSkills}
            disabled={editSkill}
          />
        )}

        {infoModal === "Otras Skills" && !editSkill && (
          <MultiSelect
            placeholder={`Seleccioná una ${
              infoModal === "Práctica" ? "Skill" : infoModal
            }`}
            style={{ width: "100%", height: "41px" }}
            className="w-full md:w-20rem select-clientes-home"
            panelClassName="modal-skills"
            filter
            options={transformSkills(opcionesOtrasSkills)}
            optionLabel="name"
            value={transformSkills(skillsSeleccionadas)}
            onChange={handleSkills}
            disabled={editSkill}
          />
        )}

        {infoModal === "Skill Principal" && (
          <>
            <Dropdown
              placeholder={`Seleccioná una ${
                infoModal === "Práctica" ? "Skill" : infoModal
              }`}
              style={{
                width: "100%",
                height: "41px",
                marginBottom: "15px",
                alignItems: "center",
              }}
              className="w-full md:w-20rem select-clientes-home"
              filter
              options={opcionesSkillPrincipal}
              optionLabel="name"
              value={tecnologias.find(
                (item) => item.name === tecnologiaSeleccionada.name
              )}
              onChange={(e) => {
                setTenologiaSeleccionada(e.value);
                setSubskillsSeleccionadas("");
                const selectedTecno = e.value;
                if (selectedTecno && selectedTecno._id) {
                  getSubTecnologias(selectedTecno._id);
                }
              }}
              disabled={tecnologiaSeleccionada.validated}
            />
            {/* <label className="h2-modal-habilidades">Subtecnología</label>
            <Dropdown
              placeholder={"Seleccioná una Subtecnología"}
              style={{ width: "100%", height: "41px" }}
              className={`w-full md:w-20rem select-clientes-home ${
                tecnologiaSeleccionada === "" ? "dropdown-custom-disabled" : ""
              }`}
              filter
              options={subTecnologias}
              optionLabel="name"
              value={subTecnologias.find(
                (item) => item.name === SubskillsSeleccionadas.name
              )}
              onChange={(e) => setSubskillsSeleccionadas(e.value)}
              disabled={tecnologiaSeleccionada === "" || tecnologiaSeleccionada.validated}
            /> */}
            {editSkill && (
              <Rating
                style={{
                  marginTop: "20px",
                  marginInline: "auto",
                  width: "max-content",
                }}
                disabled={tecnologiaSeleccionada.validated}
                value={tecnologiaSeleccionada.assessment || 0}
                onChange={(e) => handleRating(e, tecnologiaSeleccionada)}
                cancel={false}
              />
            )}
          </>
        )}

        {infoModal === "Certificaciones" && (
          <>
            <InputText
              placeholder={`P. ej.: Desarrollador Java`}
              style={{ width: "100%", height: "41px", marginBottom: "25px" }}
              className="w-full md:w-20rem select-clientes-home"
              value={inputOne}
              onChange={(e) => setInputOne(e.target.value)}
            />
            <label className="h2-modal-habilidades">
              Nombre de la institución*
            </label>
            <InputText
              placeholder={`P. ej.: Coderhouse`}
              style={{ width: "100%", height: "41px", marginBottom: "30px" }}
              className="w-full md:w-20rem select-clientes-home"
              value={inputTwo}
              onChange={(e) => setInputTwo(e.target.value)}
            />
            <label className="h2-modal-habilidades-certi">
              Contenido Multimedia*
            </label>
            <FileUpload
              contentClassName="file-upload-skills"
              style={{ paddingRight: 15, marginTop: "5px" }}
              chooseOptions={chooseOptions}
              auto
              name="fileUploadControl"
              customUpload
              uploadHandler={(e) => setArchivo(e.files[0])}
              accept="image/*,.pdf,.jpg"
              maxFileSize={tamañoMaxArchivo}
              emptyTemplate={
                <p className="m-0">
                  {archivoExistente
                    ? `Archivo actual: ${archivoExistente}`
                    : `Arrastra o examina archivos. (tamaño máximo ${
                        tamañoMaxArchivo / 1000 / 1000
                      } MB)`}
                </p>
              }
              invalidFileSizeMessageSummary="¡Error! "
              invalidFileSizeMessageDetail={`El tamaño del archivo a adjuntar supera el máximo permitido.`}
              onRemove={() => {
                setArchivo(null);
              }}
            />
          </>
        )}

        {infoModal === "Nivel de estudios" && (
          <>
            <Dropdown
              placeholder={"Seleccioná el nivel alcanzado"}
              style={{
                width: "100%",
                height: "41px",
                marginBottom: "10px",
                alignItems: "center",
              }}
              className="w-full md:w-20rem select-clientes-home"
              filter
              options={nivelEstudios}
              optionLabel="name"
              value={nivelEstudios.find(
                (item) => item.name === nivelEstudio.name
              )}
              onChange={(e) => setNivelEstudio(e.value)}
            />
            <label className="h2-modal-habilidades">Título*</label>
            <InputText
              placeholder={`P. ej.: Perito Mercantil`}
              style={{ width: "100%", height: "41px", marginBottom: "10px" }}
              className="w-full md:w-20rem select-clientes-home"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
            />
            <label className="h2-modal-habilidades">
              Nombre de la institución*
            </label>
            <InputText
              placeholder={`P. ej.: UTN`}
              style={{ width: "100%", height: "41px", marginBottom: "10px" }}
              className="w-full md:w-20rem select-clientes-home"
              value={nombreInsti}
              onChange={(e) => setNombreInsti(e.target.value)}
            />
          </>
        )}

        {infoModal === "Carga de cv" && (
          <>
            <FileUpload
              contentClassName="file-upload-skills"
              style={{ paddingRight: 15, marginTop: "5px" }}
              chooseOptions={chooseOptions}
              auto
              name="fileUploadControl"
              customUpload
              uploadHandler={(e) => setArchivo(e.files[0])}
              accept="image/*,.pdf,.jpg"
              maxFileSize={tamañoMaxArchivo}
              emptyTemplate={
                <p className="m-0">
                  {archivoExistente
                    ? `Archivo actual: ${archivoExistente}`
                    : `Arrastra o examina archivos. (tamaño máximo ${
                        tamañoMaxArchivo / 1000 / 1000
                      } MB)`}
                </p>
              }
              invalidFileSizeMessageSummary="¡Error! "
              invalidFileSizeMessageDetail={`El tamaño del archivo a adjuntar supera el máximo permitido.`}
              onRemove={() => {
                setArchivo(null);
              }}
            />
          </>
        )}

        {infoModal === "sugerencia de tecnología" && (
          <>
            <label className="h2-modal-habilidades">Tecnologia*</label>
            <InputText
              placeholder={`P. ej.: Java`}
              style={{ width: "100%", height: "41px", marginBottom: "20px" }}
              className="w-full md:w-20rem select-clientes-home"
              value={sugerenciaTecnologia}
              onChange={(e) => setSugerenciaTecnologia(e.target.value)}
            />
            <label className="h2-modal-habilidades">Subtecnología</label>
            <InputText
              placeholder={`P. ej.: Spring`}
              style={{ width: "100%", height: "41px" }}
              className="w-full md:w-20rem select-clientes-home"
              value={sugerenciaSubtecnologia}
              onChange={(e) => setSugerenciaSubtecnologia(e.target.value)}
              disabled={sugerenciaTecnologia === ""}
            />
          </>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "0px 20px 10px",
          overflowY: "auto",
        }}
      >
        {filtros.map((filtro) => (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 20px 10px",
            }}
          >
            <div key={filtro._id} className="filtros-select">
              <p>{filtro.name}</p>
              <i
                className="pi pi-times-circle custom-icon-habilidades"
                style={{ cursor: "pointer" }}
                onClick={() => removeFiltro(filtro)}
              ></i>
            </div>
            <Rating
              value={filtro?.assessment || 0}
              disabled={filtro.validated}
              onChange={(e) => handleRating(e, filtro)}
              cancel={false}
            />
          </div>
        ))}
      </div>
      <footer className="footer-modal-habilidades">
        <Button
          className="button-modal-habilidades-cancelar"
          onClick={() => {
            cancel(false);
            setEditSkill(false);
            setHabilidadSeleccionada("");
            if (
              (infoModal === "Nivel de estudios" ||
                infoModal === "Skill Principal") &&
              editSkill
            ) {
              open(true);
            }
          }}
        >
          Cancelar
        </Button>
        <Button
          className="button-modal-habilidades"
          onClick={() => {
            infoModal === "Práctica" &&
              (editSkill
                ? handleEliminarYActualizarSkills()
                : handleGuardarSkills());

            infoModal === "Certificaciones" &&
              (editSkill
                ? handleEditarCertificaciones()
                : handleGuardarCertificaciones());
            infoModal === "Carga de cv" &&
              (editSkill
                ? handleEditarCurriculum()
                : handleGuardarCurriculum());
            infoModal === "Nivel de estudios" &&
              (editSkill
                ? handleEditarNivelEstudio()
                : handleGuardarNivelEstudios());

            infoModal === "Skill Principal" &&
              (editSkill
                ? handleEditarTecnologias()
                : handleGuardarTecnologias());

            infoModal === "sugerencia de tecnología" &&
              handleSugerirTecnologia();
          }}
          disabled={
            (infoModal === "Práctica" &&
              ((filtros.length === 0 && skillsEliminar.length === 0) ||
                (datos.length === skillsSeleccionadas.length &&
                  skillsActualizar.length === 0))) ||
            (infoModal === "Skill Principal" &&
              !editSkill &&
              filtros.length === 0) ||
            (infoModal === "Skill Principal" &&
              editSkill &&
              tecnologiaSeleccionada === "" &&
              SubskillsSeleccionadas === "") ||
            (infoModal === "Certificaciones" &&
              !editSkill &&
              (inputOne === "" || inputTwo === "" || archivo === "")) ||
            (infoModal === "Certificaciones" &&
              editSkill &&
              (inputOne === "" || inputTwo === "")) ||
            (infoModal === "Nivel de estudios" &&
              (nivelEstudio === "" || titulo === "" || nombreInsti === "")) ||
            (infoModal === "Carga de cv" && !editSkill && archivo === "") ||
            (infoModal === "sugerencia de tecnología" &&
              sugerenciaTecnologia === "")
          }
        >
          Guardar
        </Button>
      </footer>
    </Dialog>
  );
};
